<script setup lang="ts">
  import { storeToRefs } from "pinia";
  import { Dialog, DialogContent } from "@/components/ui/dialog";
  import { Button } from "@/components/ui/button";
  import { useMMediumUploadsStore } from "@stores/mMediumUploads";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";
  import ImageLibraryHeader from "@/components/MCampaign/ImageLibrary/ImageLibraryHeader.vue";
  import ImageLibraryTagsSidebar from "@/components/MCampaign/ImageLibrary/ImageLibraryTagsSidebar.vue";
  import ImageLibraryToolbar from "@/components/MCampaign/ImageLibrary/ImageLibraryToolbar.vue";
  import ImageLibraryGrid from "@/components/MCampaign/ImageLibrary/ImageLibraryGrid.vue";
  import ImageLibraryEditDrawer from "@/components/MCampaign/ImageLibrary/ImageLibraryEditDrawer.vue";
  import ImageLibrarySelectionRail from "@/components/MCampaign/ImageLibrary/ImageLibrarySelectionRail.vue";
  import ImageLibraryLightbox from "@/components/MCampaign/ImageLibrary/ImageLibraryLightbox.vue";

  const mMediumUploadsStore = useMMediumUploadsStore();
  const { isModalLibraryVisible, hasDraftChanges, draftAddedIds, draftRemovedIds } = storeToRefs(mMediumUploadsStore);
  const { closeModalLibrary, applyDraftSelection } = mMediumUploadsStore;

  const { editedAsset, selectedIds } = storeToRefs(useMAssetLibraryStore());
</script>

<template>
  <Dialog
    :open="isModalLibraryVisible"
    @update:open="(open) => (open ? null : closeModalLibrary())">
    <DialogContent
      :show-close-button="false"
      class="flex h-[calc(100vh-40px)] max-w-[calc(100vw-60px)] flex-col gap-0 p-0">
      <ImageLibraryHeader>
        <template #actions>
          <div
            v-if="hasDraftChanges"
            class="flex items-center gap-2 text-sm text-muted-foreground">
            <span
              v-if="draftAddedIds.length"
              class="text-status-success-strong">
              +{{ draftAddedIds.length }}
            </span>
            <span
              v-if="draftRemovedIds.length"
              class="text-status-error-strong">
              −{{ draftRemovedIds.length }}
            </span>
          </div>
          <Button
            variant="outline"
            @click="closeModalLibrary">
            {{ hasDraftChanges ? "Cancel" : "Close" }}
          </Button>
          <Button
            v-if="hasDraftChanges"
            @click="applyDraftSelection">
            Save changes
          </Button>
        </template>
      </ImageLibraryHeader>
      <div class="flex flex-1 overflow-hidden">
        <ImageLibraryTagsSidebar class="w-60 shrink-0 border-r" />
        <div class="flex flex-1 flex-col overflow-hidden">
          <section class="flex flex-1 flex-col gap-3 overflow-y-auto p-6">
            <ImageLibraryToolbar />
            <ImageLibraryGrid />
          </section>
          <ImageLibrarySelectionRail v-if="selectedIds.length > 0" />
        </div>
        <ImageLibraryEditDrawer
          v-if="editedAsset"
          class="w-80 shrink-0 border-l" />
      </div>
      <ImageLibraryLightbox />
    </DialogContent>
  </Dialog>
</template>
